import { gql } from 'graphql-request'

export const GET_NOTIFICATION_COMMENT_PAGE = gql`
  query GetNotificationCommentPage(
    $pageSize: Float!
    $commentId: Float!
    $bookId: Float
    $bookChapterId: Float
  ) {
    getNotificationCommentPage(
      pageSize: $pageSize
      commentId: $commentId
      bookId: $bookId
      bookChapterId: $bookChapterId
    ) {
      page
    }
  }
`
